import PropertyType from '../Modifiers/PropertyType.js';

// `very rounded` can be removed whenever HYPE-632 is done https://hypeco.atlassian.net/browse/HYPE-632
var BlockBorderRadiusOptions = /*#__PURE__*/function (BlockBorderRadiusOptions) {
  BlockBorderRadiusOptions["square"] = "border-radius: 0;";
  BlockBorderRadiusOptions["rounded"] = "border-radius: 0.5rem;";
  BlockBorderRadiusOptions["very rounded"] = "border-radius: 3.5rem;";
  BlockBorderRadiusOptions["very-rounded"] = "border-radius: 3.5rem;";
  return BlockBorderRadiusOptions;
}(BlockBorderRadiusOptions || {}); // we need these because we can't use `very rounded` as a css variable name
var BlockBorderRadiusValues = /*#__PURE__*/function (BlockBorderRadiusValues) {
  BlockBorderRadiusValues["square"] = "0";
  BlockBorderRadiusValues["rounded"] = "0.5rem";
  BlockBorderRadiusValues["very rounded"] = "3.5rem";
  BlockBorderRadiusValues["very-rounded"] = "3.5rem";
  return BlockBorderRadiusValues;
}(BlockBorderRadiusValues || {});
var ThemeBlockBorderRadius = new PropertyType({
  name: 'BlockBorderRadius',
  propertyFromApi: 'block-border-radius',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return BlockBorderRadiusOptions[value];
  },
  defaultValue: 'rounded',
  options: BlockBorderRadiusOptions,
  selector: '.block',
  cssVariable: '--block-border-radius',
  cssVariableFunction: function cssVariableFunction(value) {
    return BlockBorderRadiusValues[value];
  }
}, 'theme');
var FormBlockBorderRadius = new PropertyType({
  name: 'BlockBorderRadius',
  propertyFromApi: 'block-border-radius',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return BlockBorderRadiusOptions[value];
  },
  defaultValue: 'rounded',
  options: BlockBorderRadiusOptions,
  selector: '.block',
  cssVariable: '--block-border-radius',
  cssVariableFunction: function cssVariableFunction(value) {
    return BlockBorderRadiusValues[value];
  }
}, 'form');

export { FormBlockBorderRadius, ThemeBlockBorderRadius };
//# sourceMappingURL=BlockBorderRadius.js.map
